import { cn } from '@/lib/utils';
import { forwardRef, type SVGProps } from 'react';
import { drawCandy, type CandyShape } from './candy-art';

export interface ArtSvgProps extends Omit<
  SVGProps<SVGSVGElement>,
  'ref' | 'fill' | 'children'
> {
  shapes: CandyShape[];
  /** The `data-icon` name. */
  name: string;
  title?: string;
}

/** One of the app's drawings in its colours: the Candy style. */
export const ArtSvg = forwardRef<SVGSVGElement, ArtSvgProps>(function ArtSvg(
  { shapes, name, title, className, ...rest },
  ref
) {
  return (
    <svg
      ref={ref}
      viewBox='0 0 48 48'
      focusable='false'
      {...rest}
      className={cn('cl-icon-candy', className)}
      data-icon={name}
      data-style='candy'
    >
      {title && <title>{title}</title>}
      {drawCandy(shapes)}
    </svg>
  );
});
